import "@cyntler/react-doc-viewer/dist/index.css";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { Document, Page, pdfjs } from "react-pdf";
import { useContext, useRef, useState } from "react";

import { FileEditorComponentProps } from "./types";
import { FilesType } from "../../forms/documents/types";
import { request } from "../../../services";
import { useModals } from "../file-menu/modal/utils/use-modals";
import { TranslationContext } from "../../../contexts/translation/index.context";
import { SessionContext } from "../../../contexts/session/index.context";
import { useSignModal } from "../../../contexts/sign-modal/index.context";
import IconKey from "../../../assets/key.png";
import IconSignKey from "../../../assets/sign-key.png";
//Components
import FileMenu from "../file-menu";
import Popconfirm from "../popconfirm-files";
import SaveFiles from "./save-files";
import PopconfirmElectronicMail from "../popconfirm-electronic-mail/generate";
//UI
import Space from "antd/lib/space";
import Checkbox from "antd/lib/checkbox";
import Card from "antd/lib/card";
import Tooltip from "antd/lib/tooltip";
import Button from "antd/lib/button";
import CheckCircleOutlined from "@ant-design/icons/CheckCircleOutlined";
import type { CheckboxChangeEvent } from "antd/es/checkbox";
import DownOutlined from "@ant-design/icons/DownOutlined";
import Dropdown from "antd/lib/dropdown";
import FileExcelOutlined from "@ant-design/icons/FileExcelOutlined";
import FileImageOutlined from "@ant-design/icons/FileImageOutlined";
import FileJpgOutlined from "@ant-design/icons/FileJpgOutlined";
import FilePdfOutlined from "@ant-design/icons/FilePdfOutlined";
import FileWordOutlined from "@ant-design/icons/FileWordOutlined";
import FileZipOutlined from "@ant-design/icons/FileZipOutlined";
import FormOutlined from "@ant-design/icons/FormOutlined";
import type { MenuProps } from "antd/es/menu/menu";
import Modal from "antd/lib/modal";
import MoreOutlined from "@ant-design/icons/MoreOutlined";
import Radio from "antd/lib/radio";
import type { RadioChangeEvent } from "antd/es/radio";
import Spin from "antd/lib/spin";
import UpOutlined from "@ant-design/icons/UpOutlined";
import ZoomInOutlined from "@ant-design/icons/ZoomInOutlined";
import ZoomOutOutlined from "@ant-design/icons/ZoomOutOutlined";
import styles from "./styles.module.scss";
import { useLocation } from "react-router-dom";
import BarcodeOutlined from "@ant-design/icons/BarcodeOutlined";
// pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
import checkBefore from '../../../helpers/selectionOfActions';
import message from "antd/lib/message";

export default function FileEditorComponent(props: FileEditorComponentProps) {
  const { files } = props;
  const location = useLocation();
  const { intl } = useContext(TranslationContext);
  const { sessionData } = useContext(SessionContext);
  const {
    openSignModal,
    selectedFiles,
    setSelectedFiles,
    onChange,
    handleSelectAll,
  } = useSignModal();
  // const [file, setFile] = useState<FilesType[]>([]);
  const [file, setFile] = useState<FilesType | null>(null);
  // const [selectedFiles, setSelectedFiles] = useState<number[]>([]);
  const [editInfoBtnDisabled, setEditInfoBtnDisabled] = useState(true);
  const [numPages, setNumPages] = useState<number>(0);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const containerRef = useRef<HTMLDivElement>(null);
  // const { modalsState, showModal, hideModal } = useModals(["isSignFiles"]);
  const [token, setToken] = useState("");
  const [isTemplateParametersModalOpen, setIsTemplateParametersModalOpen] =
    useState(false);
  const [isShowFileModalOpen, setShowFileModalOpen] = useState(false);
  const [pageFormatValue, setPageFormatValue] = useState(1);
  const [pageOrientationValue, setPageOrientationValue] = useState(1);
  const [spinFlag, setSpinFlag] = useState(true);
  const [zoom, setZoom] = useState(1.0);
  const [barcodeResponse, setBarcodeResponse] = useState<any>(null);
  const isForSignature = props.url === "/documents/for-signature";

  const [idRezerv, setIdRezerv] = useState<number|null>(null);


  const typeDocMap: Record<string, number> = {
    "/documents/incoming": 1,
    "/documents/outcoming": 2,
    "/documents/internal": 3,
  };
  const typeDocId = typeDocMap[location.pathname];

  const scrollContainer = (direction: "up" | "down") => {
    if (containerRef.current) {
      const container = containerRef.current;
      const scrollAmount = direction === "up" ? -80 : 80;
      container.scrollBy({
        top: scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const styleRadioGroup: React.CSSProperties = {
    display: "flex",
    flexDirection: "column",
    gap: 8,
  };

  // const onChange = (id: number) => (e: CheckboxChangeEvent) => {
  //   setSelectedFiles((prev) =>
  //     e.target.checked ? [...prev, id] : prev.filter((fileId) => fileId !== id)
  //   );
  // };

  // const handleSelectAll = () => {
  //   setSelectedFiles(files.map((file) => file.id));
  // };

  const archiveExtensions = [".zip", ".rar", ".7z"];

  const handleGetFile = (id: number, isSign?: boolean, ext?: string) => {
      console.log("handleGetFile METHOD ", id, isSign, ext);

    if (archiveExtensions.includes(ext?.toLowerCase() || "")) {

      // setSelectedFiles(!isSign ? [id] : []); Компонент закоментував щоб отримати інформацію про архів від сервера та надати можливість редагування інформації
      // setEditInfoBtnDisabled(false);
      // return;
    }

    // console.log("ID REZERV ", idRezerv)
    setIdRezerv(id)
    fetchFile(id);
    setSelectedFiles(!isSign ? [id] : []);
    // setEditInfoBtnDisabled(false); // Компонент де встановлюється видимість кнопки редагування файлу Вхідні/Вихідні...
  };

  const fetchFile = async (fileId: number) => {
    // console.log("Fetch file in addbarcode")
    setEditInfoBtnDisabled(true);

    setSpinFlag(false);
    setFile(null);
    const content = (
      await request(
        `${location.pathname.split("/").slice(0, 2).join("/")}/getfiles`,
        {
          method: "post",
          body: { id: sessionData.bta_documents_id, fileId },
          cancelTokenKey: "getfiles",
        }
      )
    )?.content;
    // console.log("CONTENT FILE ", content);
    setFile(content?.[0] || null);
    setSpinFlag(true);
    setEditInfoBtnDisabled(false);
  };

  const onAddBarcode = async (selectFile: object) => {
    // console.log('BARCODE ', selectFile);
  //Компонент перевірка на доступ до внесення даних чи змін
  let accessRights = await checkBefore(location.pathname, props.url, 'add-barcode');
    if (!accessRights) {
      message.error(intl("you-do-not-have-access-rights"));
      return;
    }


    var key = "add-barcode";

    try {
      // Тут відбувається встановлення повідомлення про процесс нанесення штрих коду та зміна відображення файлу на уже з штрих кодом
      message.loading({content: intl("barcode-adding-process"), key, duration: 0})
      const addBarcodeResponse = await request(
        `${location.pathname.split("/").slice(0, 2).join("/")}/addbarcode`,
        {
          method: "post",
          body: {
            fileId: selectFile,
            documentId: sessionData?.bta_documents_id,
            typeDocId,
          },
          cancelTokenKey: "addbarcode",
        }
      );



      if (!addBarcodeResponse.success) {
        message.error({content: intl("add-barcode-error"), key, duration: 3});
        throw new Error("Failed to add barcode");
      }

      if (addBarcodeResponse.success) { // Перевірка відповіді нанесення штрих коду та зміна файлу
        if (idRezerv !== null && typeof idRezerv === "number") {
          await fetchFile(idRezerv!);
          setIdRezerv(null) // Резервний id для отримання того ж самого файлу на який нанесли штрих код
        } 
        message.success({content:intl("add-barcode-confirm"), key, duration: 3});
      }
    } catch (error) {
      console.error("Error in file-editor index.tsx:", error);
    }
  };

  const showModal = async () => {
  //Компонент перевірка на доступ до внесення даних чи змін
  let accessRights = await checkBefore(location.pathname, props.url, 'add-barcode');
    if (!accessRights) {
      message.error(intl("you-do-not-have-access-rights"));
      return;
    }

    setIsTemplateParametersModalOpen(true);
  };

  const create_show_url = (bytes: number[]) => { //Функція для відображення шаблону на новій вкладці

      const UnitArr8 = Uint8Array.from(bytes)

      const blobTemplates = new Blob([UnitArr8], {type: "application/pdf"});

      const url = window.URL.createObjectURL(blobTemplates)

      window.open(url, "_blank")
  }

  const handleOk = async () => {
    var key = "add-barcode";
    try {
      message.loading({content: intl("template-creating"), key, duration: 0})
      const addBarcodeResponse = await request(
        `${location.pathname.split("/").slice(0, 2).join("/")}/addbarcode`,
        {
          method: "post",
          body: {
            documentId: sessionData?.bta_documents_id,
            typeDocId,
            pageFormatValue,
            pageOrientationValue,
            extention: ".pdf",
          },
          cancelTokenKey: "addbarcode",
        }
      );

      // console.log("Barcode answer template ", addBarcodeResponse)
      if (!addBarcodeResponse.success) {
        message.loading({content: intl("template-creating-error"), key, duration: 3})
        throw new Error("Failed to add barcode");
      }
      // setBarcodeResponse(addBarcodeResponse.content.data);
      setIsTemplateParametersModalOpen(false);
      // setShowFileModalOpen(true);

      const templateBytes = addBarcodeResponse.content.data;

      message.loading({content: intl("template-created"), key, duration: 3})
      create_show_url(templateBytes)
      
    } catch (error) {
      console.error("Error in file-editor index.tsx:", error);
    }
  };

  const handleCancel = () => {
    setIsTemplateParametersModalOpen(false);
    setShowFileModalOpen(false);
  };

  const onPageFormatChange = (e: RadioChangeEvent) => {
    setPageFormatValue(e.target.value);
  };

  const onPageOrientationChange = (e: RadioChangeEvent) => {
    setPageOrientationValue(e.target.value);
  };

  const handleZoomOut = () => {
    setZoom((prevZoom) => Math.max(prevZoom - 0.2, 0.4));
  };

  const handleZoomIn = () => {
    setZoom((prevZoom) => Math.min(prevZoom + 0.2, 3.0));
  };

  // const bufferToBlob = (
  //   buffer: { type: string; data: number[] },
  //   mimeType: string
  // ) => {
  //   const byteArray = new Uint8Array(buffer.data);
  //   return new Blob([byteArray], { type: mimeType });
  // };

  // function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
  //   setNumPages(numPages);
  // }

  // function changePage(offset: number) {
  //   setPageNumber((prevPageNumber) => prevPageNumber + offset);
  // }

  // function previousPage() {
  //   changePage(-1);
  // }

  // function nextPage() {
  //   changePage(1);
  // }

  const fileIconMap = {
    ".pdf": FilePdfOutlined,
    ".doc": FileWordOutlined,
    ".docx": FileWordOutlined,
    ".jpg": FileImageOutlined,
    ".jpeg": FileImageOutlined,
    ".png": FileImageOutlined,
    ".bmp": FileImageOutlined,
    ".gif": FileImageOutlined,
    ".xlsx": FileExcelOutlined,
    ".rar": FileZipOutlined,
    ".zip": FileZipOutlined,
    ".7z": FileZipOutlined,
  };

  // const mimeTypeMap: { [key: string]: string } = {
  //   ".txt": "text/plain",
  //   ".pdf": "application/pdf",
  //   ".doc": "application/msword",
  //   ".docx":
  //     "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  //   ".xls": "application/vnd.ms-excel",
  //   ".xlsx":
  //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   ".jpg": "image/jpg",
  //   ".jpeg": "image/jpeg",
  //   ".png": "image/png",
  //   ".bmp": "image/bmp",
  // };

  const items: MenuProps["items"] = [
    ...(props.url !== "/documents/resolutions" ?
      [
        {
      key: "1",
      label: (
        <div className={styles["button-text"]}>
          <Button
            className={styles["button-text"]}
            onClick={showModal}
            icon={<BarcodeOutlined />}
          >
            {intl("applying-a-barcode")}
          </Button>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div className={styles["button-text"]}>
          <Button
            className={styles["button-text"]}
            disabled={selectedFiles.length === 0}
            onClick={()=>onAddBarcode(selectedFiles)}
            icon={<BarcodeOutlined />}
          >
            {intl("applying-a-barcode-to-a-file")}
          </Button>
        </div>
      ),
    },
      ] : []
    ),
    ...(props.url === "/documents/outcoming"
      ? [
          {
            key: "3",
            label: (
              <PopconfirmElectronicMail
                name="generate-general-letter"
                isCombined={true}
              />
            ),
          },
          {
            key: "4",
            label: (
              <PopconfirmElectronicMail
                name="generate-letter-by-recipient"
                isCombined={false}
              />
            ),
          },
        ]
      : []
    ),
  ];

  const archiveExtension = [".zip", ".7z", ".rar"];

  function isPlaceholderPdf(data?: number[]): boolean {
  if (!data || !Array.isArray(data)) return false;

  return data.length === 1124;
}


  const renderFile = (data?: any) => {
    const isArchive = archiveExtension.find(
      (item) => item === file?.fileExtention.toLowerCase()
    );
    if (!file || isArchive) {
    console.log("RENDER FILES ", file);
      return null;
    }

    const { name_file_view, fileBody, fileExtention } = file;
    console.log("fileBody.data.length =", fileBody?.data?.length);


    // Перевірка чи є тіло файлу та його дані
    if (!fileBody || !fileBody.data) {
      return (
        <div className={styles["viewer-container"]}>
          <p
            style={{
              width: "100%",
              color: "red",
              fontSize: 16,
              textAlign: "center",
            }}
          >
            {intl("invalid-file-link")}
          </p>
        </div>
      );
    }

  const isPdf = fileExtention?.toLowerCase() === ".pdf";
  // Перевірка чи файл є PDF та чи є в ньому дані (перевірка на data.length === 1124)
  if (isPdf && isPlaceholderPdf(fileBody.data)) {
    return (
      <div className={styles["viewer-container"]}>
        <p
          style={{
            width: "100%",
            color: "red",
            fontSize: 16,
            textAlign: "center",
          }}
        >
          {intl("invalid-file-link")}
        </p>
      </div>
    );
  }

    const fileBlob = new Blob([new Uint8Array(/* data ?? */ fileBody.data)]);
    const fileUrl = URL.createObjectURL(fileBlob);
    const isImage = [".jpg", ".jpeg", ".png", ".bmp", ".gif"].includes(
      fileExtention
    );

    const docs = [
      {
        uri: fileUrl,
        fileName: name_file_view,
        fileType: fileExtention.replace(".", ""),
      },
    ];

    const config = {
      pdfZoom: {
        defaultZoom: 1,
        zoomJump: 0.2,
      },
    };

    return (
      <div className={styles["viewer-container"]}>
        {isImage && (
          <div className={styles["zoom-buttons"]}>
            <Button onClick={handleZoomOut} icon={<ZoomOutOutlined />} />
            <Button onClick={handleZoomIn} icon={<ZoomInOutlined />} />
          </div>
        )}
        {isImage ? (
          <div className={styles["image-viewer"]}>
            <img
              src={fileUrl}
              alt={name_file_view}
              style={{
                transform: `scale(${zoom})`,
                transformOrigin: "top left",
                transition: "transform 0.2s ease",
              }}
            />
          </div>
        ) : (
          <DocViewer
            className={styles["doc-viewer"]}
            documents={docs}
            pluginRenderers={DocViewerRenderers}
            config={config}
          />
        )}
      </div>
    );
  };

  // const getIframeToken = async () => {
  //   try {
  //     const response = await request(
  //       `${location.pathname.split("/").slice(0, 2).join("/")}/gettoken`,
  //       {
  //         method: "post",
  //         body: {
  //           id: sessionData?.bta_documents_id,
  //           page: location.pathname.split("/").pop(),
  //         },
  //         cancelTokenKey: "gettoken",
  //       }
  //     );

  //     if (!response.success) {
  //       throw new Error("Failed to fetch token");
  //     }

  //     setToken(response.content);

  //     await request("/sign/sign-files", {
  //       method: "post",
  //       body: {
  //         id: sessionData?.bta_documents_id,
  //         page: location.pathname.split("/").pop(),
  //         filesId: selectedFiles.join(", "),
  //       },
  //       cancelTokenKey: "signfiles",
  //     });
  //     // return `http://192.168.2.44:3000/?token=${token}`;
  //   } catch (error) {
  //     console.error("Error fetching the token:", error);
  //     return "";
  //   }
  // };

  // interface FileData {
  //   uid: number;
  //   name: string;
  //   type: string;
  //   data: string;
  //   isSignature: boolean;
  // }

  // const saveFiles = async () => {
  //   try {
  //     const response: { success: boolean; data: FileData[] } = await request(
  //       "/save/save-files",
  //       {
  //         method: "post",
  //         body: {
  //           id: sessionData?.bta_documents_id,
  //           page: location.pathname.split("/").pop(),
  //           filesId: selectedFiles.join(", "),
  //         },
  //         cancelTokenKey: "savefiles",
  //       }
  //     );

  //     if (response.success && response.data) {
  //       response.data.forEach((file) => {
  //         const mimeType = mimeTypeMap[file.type] || "application/octet-stream";
  //         const byteArray = Uint8Array.from(atob(file.data), (c) =>
  //           c.charCodeAt(0)
  //         );
  //         const blob = new Blob([byteArray], { type: mimeType });
  //         const url = URL.createObjectURL(blob);
  //         const link = document.createElement("a");
  //         link.href = url;
  //         link.download = file.name;
  //         document.body.appendChild(link);
  //         link.click();
  //         document.body.removeChild(link);
  //         URL.revokeObjectURL(url);
  //       });
  //     } else {
  //       console.error("Failed to fetch files from the server.");
  //     }
  //   } catch (error) {
  //     console.error("Error saving files:", error);
  //   }
  // };

  return (
    <div>
      <div>
        {!isForSignature && (
          <Space style={{ padding: 10 }}>
            <FileMenu file={file} disabled={editInfoBtnDisabled} />
            <Popconfirm
              filesId={selectedFiles}
              disabled={selectedFiles.length === 0}
              onSuccessDelete={() => {
                setFile(null);
                setSelectedFiles([]);
              }}
            />

            <Tooltip title={intl(`sign`)}>
              <Button
                icon={<FormOutlined />}
                onClick={() => {
                  // showModal("isSignFiles");
                  // getIframeToken();
                  openSignModal(sessionData, location.pathname);
                }}
                style={{ border: "none", backgroundColor: "inherit" }}
                disabled={selectedFiles.length === 0}
              />
            </Tooltip>
            
            <Dropdown
              className={styles["dropdown"]}
              menu={{ items }}
              trigger={["click"]}
              placement="bottomRight"
            >
              <Button>
                <MoreOutlined />
              </Button>
            </Dropdown>
            <Modal
              className={styles["modal"]}
              open={isTemplateParametersModalOpen}
              onOk={handleOk}
              onCancel={handleCancel}
              okText={intl("ok")}
            >
              <Space size={"large"}>
                <Radio.Group
                  style={styleRadioGroup}
                  onChange={onPageFormatChange}
                  value={pageFormatValue}
                  options={[
                    { value: 1, label: "A4" },
                    { value: 2, label: "A5" },
                  ]}
                />
                <Radio.Group
                  style={styleRadioGroup}
                  onChange={onPageOrientationChange}
                  value={pageOrientationValue}
                  options={[
                    { value: 1, label: intl("portrait-orientation") },
                    { value: 2, label: intl("landscape-orientation") },
                  ]}
                />
              </Space>
            </Modal>
            <Modal
              className={styles["modal"]}
              open={isShowFileModalOpen}
              okText={intl("ok")}
              onOk={handleCancel}
              onCancel={handleCancel}
            >
              {renderFile(barcodeResponse)}
            </Modal>
          </Space>
        )}
      </div>
      <div style={{ display: "flex" }}>
        <div
          style={{
            width: "max-content",
            height: "calc(100vh - 150px)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <UpOutlined
            onClick={() => scrollContainer("up")}
            style={{
              fontSize: "12px",
              cursor: "pointer",
              marginBottom: "10px",
            }}
          />
          <div
            ref={containerRef}
            style={{
              // width: "200px",
              height: "calc(100vh - 150px)",
              overflowY: "hidden",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {files.map((file, index) => {
              const Icon =
                fileIconMap[file.fileExtention as keyof typeof fileIconMap];
              return (
                <div key={index} style={{ marginBottom: "10px" }}>
                  <Card
                    hoverable
                    size="small"
                    style={{
                      width: "max-content",
                      textAlign: "center",
                      padding: "5px",
                    }}
                    onClick={() =>
                      handleGetFile(file.id, file.isSign, file.fileExtention)
                    }
                  >
                    <Space align="start">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                        }}
                      >
                        <CheckCircleOutlined
                          style={{
                            fontSize: "14px",
                            marginBottom: "8px",
                            color: file.isOriginal ? "#077e96" : "#e4e3e6",
                          }}
                        />
                        <img
                          src={file.isSign ? IconSignKey : IconKey}
                          alt="Icon"
                          style={{
                            width: "14px",
                            height: "14px",
                          }}
                        />
                        <Checkbox
                          checked={selectedFiles.includes(file.id)}
                          onChange={onChange(file.id)}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <Icon
                          style={{ fontSize: "32px", marginBottom: "8px" }}
                        />
                        <Tooltip title={file.name_file_view}>
                          <div>{`${file.name_file_view.slice(0, 5)}...`}</div>
                        </Tooltip>
                      </div>
                    </Space>
                  </Card>
                </div>
              );
            })}
          </div>
          <DownOutlined
            onClick={() => scrollContainer("down")}
            style={{
              fontSize: "12px",
              cursor: "pointer",
              marginTop: "10px",
              marginBottom: "10px",
            }}
          />
          <Button
            className={styles["file-list-button"]}
            onClick={/* handleSelectAll */ () => handleSelectAll(files)}
          >
            {intl("select-all-files")}
          </Button>
          {/* <Button
            className={styles["file-list-button"]}
            onClick={saveFiles}
            disabled={selectedFiles.length === 0}
          >
            {intl("save-files")}
          </Button> */}
          <SaveFiles
            selectedFiles={selectedFiles}
            bta_documents_id={sessionData?.bta_documents_id}
          />
        </div>
        <div
          style={{
            width: "100%",
            maxWidth: "100%",
            height: "80vh",
            overflowY: "auto",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {!spinFlag ? <Spin size="large" /> : renderFile()}
          </div>
        </div>
      </div>
    </div>
  );
}
